const USER_KEY = 'pass_the_pushups_user';
const CLAIM_KEY = 'pass_the_pushups_claimed_rooms';

export function clearLegacyLocalProgress(userId: string): void {
  localStorage.removeItem(`${USER_KEY}_${userId}`);
  localStorage.removeItem(`${CLAIM_KEY}_${userId}`);
}
